import { render } from "./WallpaperLines.vue?vue&type=template&id=9c28be68"
import script from "./WallpaperLines.vue?vue&type=script&lang=js"
export * from "./WallpaperLines.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__